import script from "./VerificationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerificationList.vue?vue&type=script&setup=true&lang=ts"

import "./VerificationList.vue?vue&type=style&index=0&id=f468974c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f468974c"]])

export default __exports__